import './Popup.scss';
import Footer from "../Footer/Footer";

const Popup = () => {
	const initPopup = () => {
		let popup = document.querySelector('#js-popup');
		let closers = document.querySelectorAll('.js-popup-close');
		if (popup && closers) {
			let links = popup.querySelector('.popup__window__container__content').querySelectorAll('a');
			if (sessionStorage.getItem('jsPopupHide') == 1) {
			
			} else {
				setTimeout(function () {
					popup.classList.add('active');
				}, 2500);
			}
			
			closers.forEach(function (closer) {
				closer.addEventListener('click', function (event) {
					event.preventDefault();
					popup.classList.remove('active');
					sessionStorage.setItem('jsPopupHide', 1);
				})
			})
			
			if (links) {
				links.forEach(function (link) {
					link.addEventListener('click', function (event) {
						sessionStorage.setItem('jsPopupHide', 1);
					})
				})
			}
 		}
	}
	
	initPopup();
}

export default Popup;
